import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const CorrespondentTransactionsReport = lazy(() => import('./pages/reports/CorrespondentTransactionsReport'));
const SubsidiarySupervisors = lazy(() => import('./pages/subsidiaryManagement/SubsidiarySupervisors'));
const UnlockUsers = lazy(() => import('./pages/userManagement/UnlockUsers'));
const UsersPage = lazy(() => import('./pages/userManagement/UsersPage'));
const UsersReportCorrespondent = lazy(() => import('./pages/reports/UsersReport'));

/**
 * Correspondent feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const correspondentPages = (displayName: string): Record<string, React.ReactNode> => ({
  repTransactions: <CorrespondentTransactionsReport title={displayName} />,
  subsidiaryResponsible: <SubsidiarySupervisors />,
  unlockUsers: <UnlockUsers title={displayName} />,
  correspondentUser: <UsersPage />,
  bankUser: <UsersPage bankAdmin={true} />,
  crpdntUserReport: <UsersReportCorrespondent />,
});
